import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/users';

// GETALL
function getAll(state, action) {
  state.getAll.data = action.payload.data ? action.payload.data:[];
}

function conexionGetAll(state, action) {
  state.getAll.connection= action.payload.connection;
}

function errorGetAll(state, action) {
  state.getAll.error= action.payload.error ? action.payload.error:false;
  state.getAll.message= action.payload.message ? action.payload.message:"";
}

// GETBYID
function getById(state, action) {
  state.getById.data = action.payload.data ? action.payload.data:[];
}

function conexionGetById(state, action) {
  state.getById.connection= action.payload.connection;
}

function errorGetById(state, action) {
  state.getById.error= action.payload.error ? action.payload.error:false;
  state.getById.message= action.payload.message ? action.payload.message:"";
}

// CREATE
function create(state, action) {
  state.create.result = action.payload.result ? action.payload.result:false;
}

function conexionCreate(state, action) {
  state.create.connection= action.payload.connection;
}

function errorCreate(state, action) {
  state.create.error= action.payload.error ? action.payload.error:false;
  state.create.message= action.payload.message ? action.payload.message:"";
}

function createReset(state, action) {
  state.create.result=false;
  state.create.connection= false;
  state.create.error= false;
  state.create.message= "";
}

//UPDATE
function update(state, action) {
  state.update.result = action.payload.result ? action.payload.result:false;
}

function conexionUpdate(state, action) {
  state.update.connection= action.payload.connection;
}

function errorUpdate(state, action) {
  state.update.error= action.payload.error ? action.payload.error:false;
  state.update.message= action.payload.message ? action.payload.message:"";
}

function updateReset(state, action) {
  state.update.result=false;
  state.update.connection= false;
  state.update.error= false;
  state.update.message= "";
}



/**
 * Conexión
 */
const usersReducer = createSlice({
  name: 'users',
  initialState: initState,
  reducers: {
    // GETALL
    getAll,
    conexionGetAll,
    errorGetAll,
    // GETBYID
    getById,
    conexionGetById,
    errorGetById,
    // CREATE
    create,
    conexionCreate,
    errorCreate,
    createReset,
    //UPDATE
    update,
    conexionUpdate,
    errorUpdate,
    updateReset
  },
});

export const usersActions = {
  ...usersReducer.actions,
};

export default usersReducer.reducer;
